<span class="field-view-value">••••••••</span>
